import { render, staticRenderFns } from "./GoldStandardSection.vue?vue&type=template&id=1f1e2714&scoped=true"
import script from "./GoldStandardSection.vue?vue&type=script&lang=js"
export * from "./GoldStandardSection.vue?vue&type=script&lang=js"
import style0 from "./GoldStandardSection.vue?vue&type=style&index=0&id=1f1e2714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e2714",
  null
  
)

export default component.exports